import { CellulaFileViewerItem } from './_file_viewer_item.component';
import { CellulaFileViewerRoot } from './_file_viewer_root.component';

export const FileViewer = {
	Root: CellulaFileViewerRoot,
	Item: CellulaFileViewerItem,
} as const;
